import React from 'react'
import { observer } from 'mobx-react'
import { CardContent } from 'components/Card'
import Button from 'components/Button'
import JobProgressionViewModel from '../JobProgressionViewModel'

interface Props {
  vm: JobProgressionViewModel
}

export default observer(function WaitingOnClientProgressionActions({
  vm,
}: Props) {
  return (
    <>
      <CardContent>
        <Button
          type="primary"
          size="wide-slim"
          onClick={() => vm.answerReadyToFile(false)}
          dataTest="job-progression-set-ready-to-file-button"
        >
          {vm.isOutsourcingExtension ? 'Ready to Continue' : 'Ready to File'}
        </Button>
      </CardContent>
    </>
  )
})
